import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Form, Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import Loader from 'components/layout/Loader';
import SimpleSubmitButton from 'components/layout/SimpleSubmitButton';
import Data from 'components/Data';

import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';

import EntityStateUpdater from 'component/EntityStateUpdaterV2';

class PasswordForm extends EntityStateUpdater {
  constructor(props) {
    super(props, { metaIdentifier: 'password', dataProps: 'empty' }); // pass the configuration to entity state updater

    this.state = {
      ...this.state,
      elementsType: 'password',
    };
  }

  formSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    this.validateEntity(() => {
      this.props.onSubmit(this.state.entity.__getStoredData());
    });
  };

  toggleShowPassword = (checkboxName, checkboxValue) => {
    if (checkboxValue) {
      this.setState({ elementsType: 'text' });
    } else {
      this.setState({ elementsType: 'password' });
    }
  };

  render() {
    const {
      intl: { messages },
      formStatus,
    } = this.props;
    const { entity, entityLoaded, elementsType } = this.state;

    return (
      <Row>
        <Data dataName="password" /> {/* fetch meta data */}
        <Col xs={12}>
          {!entityLoaded ? (
            <Loader />
          ) : (
            <Form method="post" onSubmit={this.formSubmit}>
              <div class="panel panel-transparent">
                <div class="form-group-attached">
                  <FormInput
                    type={elementsType}
                    name="password"
                    label={messages.password}
                    value={entity.getPassword}
                    meta={entity.getPasswordMetaInformation}
                    validation={entity.getPasswordValidationResult}
                    onChange={this.updateEntity}
                  />
                  <FormInput
                    type={elementsType}
                    name="repeatPassword"
                    label={messages.repeat_password}
                    value={entity.getRepeatPassword}
                    meta={entity.getRepeatPasswordMetaInformation}
                    validation={entity.getRepeatPasswordValidationResult}
                    onChange={this.updateEntity}
                  />
                </div>

                <div class="m-t-10">
                  <FormSwitchery value={1} label={messages.show_password_text} onChange={this.toggleShowPassword} />
                </div>

                <div class="text-right m-t-15">
                  <SimpleSubmitButton
                    label={messages.save}
                    entityChanged={this.getEntityChanged()}
                    errorButton={this.hasValidationErrorButton()}
                    pending={formStatus.pending}
                  />
                </div>
              </div>
            </Form>
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(PasswordForm)));
